import { render, staticRenderFns } from "./UnitActionsDropdown.vue?vue&type=template&id=b1b361fc"
import script from "./UnitActionsDropdown.vue?vue&type=script&lang=js"
export * from "./UnitActionsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports